import React, {Component} from 'react';
import BackendApiService from "../../services/BackendApiService";

import SaleNotesSummary from "./SaleNotesSummary";
import _ from 'lodash'

class SaleNotesSummaryContainer extends Component {
    constructor(props) {
        super(props);
        this.state     = {
            full_pending: 0,
            full_amount_pending: 0,
            range_pending: 0,
            range_amount_pending: 0,
            in_filter: false
        };
        this.fetchData = this.fetchData.bind(this);
    }

    async fetchData(params) {
        let in_filter = false;
        const filters = ['EMITED_DATE_FROM','EMITED_DATE_TO','STATUS','LEGAL_ID'];
        try{
            const keys = Object.keys(JSON.parse(params.where));
            const filterApplied = _.intersection(filters, keys);
            in_filter = filterApplied.length > 0
        }catch (e){

        }
        try {
            const saleNotesPendingSummary = await BackendApiService.getInvoiceCenterBillingPendingSummary(params);
            console.log(saleNotesPendingSummary);
            this.setState({
                full_pending:saleNotesPendingSummary.fullResult.cantidad,
                full_amount_pending:saleNotesPendingSummary.fullResult.monto,
                range_pending:saleNotesPendingSummary.filterResult.cantidad,
                range_amount_pending:saleNotesPendingSummary.filterResult.monto,
                in_filter
            });

        } catch (e) {
            console.log("ocurrio un error al recuperar el resumen de cierres")
            this.setState({
                full_pending:0,
                full_amount_pending:0,
                range_pending:0,
                range_amount_pending:0,
                in_filter
            });
        }
    }

    render() {
        return (
            <div>
                <SaleNotesSummary
                    full_pending={this.state.full_pending}
                    full_amount_pending={this.state.full_amount_pending}
                    range_pending={this.state.range_pending}
                    range_amount_pending={this.state.range_amount_pending}
                    in_filter={this.state.in_filter}
                />
            </div>
        );
    }
}

export default SaleNotesSummaryContainer;
